export const HOMEPAGE_HERO_DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';
export const HOMEPAGE_HERO_IMAGE_WIDTH = 948;
export const HOMEPAGE_HERO_IMAGE_QUALITY = 80;
